//=> Import React
import * as React from "react"

//=> import Images
import logoBerthe from "../../images/ImageBerthe.png"


//=> Import Styles
import { header, headerContent, image } from "./styles.module.scss"

//=> Component
const HeaderAcceuil = () => {
  return (
    <header className={header}>
      <div className={headerContent}></div>
    </header>
  )
}

export default HeaderAcceuil